
import { Sale } from "@/models/base";
import AppTimeago from "@/components/common/Timeago.vue";
import Vue from "vue";
export default Vue.extend({
	props: {
		importReferencedSales: {
			type: Array as ()=>Sale[],
			required: true
		}
	},
	methods: {
		openSale(saleId: number) {
			this.$router.push(`/sales/info/${saleId}`);
		},
	},
	components: {
		AppTimeago
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
